/**
 * AppSwitch — presentational MUI Switch wrapper with an inline label
 * (WSRPDM-0011).
 *
 * Renders as `role="switch"` (MUI Switch's native role) — tests must query
 * it that way, not `role="checkbox"` (the WSRPDM-0005 lesson; see
 * tests/e2e/smoke.spec.ts).
 */
import { FormControlLabel, Switch } from '@mui/material';

interface AppSwitchProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  /** Native tooltip — for a switch whose label has no room for secondary help text (WSRPDM-0038). */
  title?: string | undefined;
}

export function AppSwitch({ label, checked, onChange, disabled = false, title }: AppSwitchProps) {
  return (
    <FormControlLabel
      title={title}
      control={
        <Switch
          checked={checked}
          onChange={(event) => onChange(event.target.checked)}
          disabled={disabled}
        />
      }
      label={label}
    />
  );
}
